import { shakeElement } from '~/shared/utils/animation';
import { getCSRFToken } from '~/shared/utils/request';
import { AuthScreen } from './base-auth-screen';

export class PasscodeAuthScreen extends AuthScreen {
  constructor(screen) {
    const formHandlerOptions = {
      defaultServerErrorMsg: 'Incorrect passcode',
      onSubmitStart: () => { this.codeInput.disabled = true; },
      onError: () => {
        shakeElement(this.codeInput);
        this.codeInput.disabled = false;

        setTimeout(() => {
          this.codeInput.value = '';
        }, 0);
      },
    };

    super(screen, formHandlerOptions);
    this.codeInput = screen.querySelector('[data-passcode-input]');

    if (!this.codeInput) {
      throw new Error('Code input not found for passcode auth screen');
    }

    this.bindListeners();
  }

  bindListeners() {
    const resendCodeButton = this.screen.querySelector('[data-resend-code]');
    resendCodeButton?.addEventListener('click', this.resendCode.bind(this));

    this.screen.addEventListener('drb-code-input:complete', () => {
      this.form.requestSubmit();
    });
  }

  async resendCode() {
    const resendPath = this.screen.getAttribute('data-resend-code-path');
    const resendLogin = this.screen.getAttribute('data-resend-code-login');

    if (!resendPath || !resendLogin) {
      console.error('Resend code path or login not set for passcode auth screen');
      return;
    }

    const defaultErrorMsg = 'Error resending passcode.';

    try {
      this.formHandler?.setServerMessage('');

      const response = await fetch(resendPath, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': getCSRFToken(),
        },
        body: JSON.stringify({
          login: resendLogin,
        }),
      });

      if (response.status === 429) {
        throw new Error('Too many requests. Please try again later.');
      }

      if (!response.ok) {
        throw new Error(defaultErrorMsg);
      }

      // reset code input and show success message
      this.formHandler?.setServerMessage('Passcode resent. Please check your email.', false);
      this.codeInput.value = '';
    } catch (error) {
      this.formHandler?.setServerMessage(error?.message || defaultErrorMsg);
      console.error(error);
    }
  }
}
